import { createApi } from '@reduxjs/toolkit/query/react';

import { CMSStandardSlug } from '@/slices/cms/standards/cmsStandards.types';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

import { CmsTopicItem } from './cmsTopics.types';

interface CmsTopicsResponse {
  topics?: CmsTopicItem[];
}

const cmsTopicsApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api/cms/topics',
  }),
  reducerPath: 'cmsTopics',
  tagTypes: ['CmsTopics'],
  endpoints: (build) => ({
    getTopics: build.query<CmsTopicItem[], { slug: CMSStandardSlug }>({
      query: ({ slug }) => ({
        url: `/${slug}`,
        method: 'GET',
      }),
      transformResponse: (response: CmsTopicsResponse) => response.topics ?? [],
    }),
  }),
});

export default cmsTopicsApi;
